<ng-template #injectedServiceCardMenu>
  <ng-content select=".service-card-menu"></ng-content>
</ng-template>

<ng-template #injectedServiceCardActions>
  <ng-content select=".service-card-actions"></ng-content>
</ng-template>

<ng-container [ngSwitch]="displayMode">
  <ng-container *ngSwitchCase="'narrow'">
    <ng-container *ngTemplateOutlet="narrowMode"></ng-container>
  </ng-container>

  <ng-container *ngSwitchCase="'wide'">
    <ng-container *ngTemplateOutlet="wideMode"></ng-container>
  </ng-container>

  <ng-container *ngSwitchDefault>
    <ng-container *ngTemplateOutlet="wideMode"></ng-container>
  </ng-container>
</ng-container>

<ng-template #wideMode>
  <article
    class="service-card wide"
    [class.mobile]="deviceService.isMobile()"
    itemscope
    itemtype="https://schema.org/Article">
    <ng-container *ngTemplateOutlet="meta"></ng-container>

    <div *ngIf="isBrowser" class="card-cover" (click)="onOpenCardInModal()"></div>

    <div class="type" [ngClass]="eUserServiceType[type]">{{ typeLabel(type) | customLocale }}</div>

    <div class="tools-panel">
      <div #injectedTools3Ref>
        <ng-container *ngTemplateOutlet="injectedServiceCardMenu"></ng-container>
      </div>
      <ng-template [ngIf]="injectedTools3Ref?.childElementCount === 0">
        <on-ui-card-menu>
          <a class="menu-item warn" *ngIf="service.purl" [href]="service.purl">[⚠️] Panel</a>
          <div class="menu-item" *ngIf="debug$ | async" (click)="printDebugInfo()">DEBUG</div>
          <div class="menu-item" (click)="onOpenCardInModal()">
            {{ 'user-service-form-3.actions.previews' | customLocale }}
          </div>
        </on-ui-card-menu>
      </ng-template>
    </div>

    <div class="content">
      <div class="cover-wrap">
        <on-ui-cover [cover]="cover"></on-ui-cover>
      </div>

      <a [routerLink]="userServiceRoute" [attr.title]="fullTitle" class="info-block">
        <ng-template [ngIf]="deviceService.isMobile()">
          <div class="category" [class.empty]="!category">{{ category }}</div>
        </ng-template>
        <span class="subject">{{ subjectTitle }}</span>
        <div class="title">{{ title | striptags }}</div>
        <ng-template [ngIf]="!deviceService.isMobile()">
          <ng-container *ngTemplateOutlet="secondInfo"></ng-container>
        </ng-template>
      </a>
    </div>

    <ng-template [ngIf]="deviceService.isMobile()">
      <ng-container *ngTemplateOutlet="secondInfo"></ng-container>
    </ng-template>

    <div class="actions-block" [class.with-unavailable-reason]="signUpStatus()?.label">
      <div class="price-block">
        <!--        <div class="old-price">-->
        <!--          <ng-template [ngIf]="discount">-->
        <!--            <span class="price-without-discount">-->
        <!--              {{ formatPriceWithoutDiscount(getPriceTier(price_tier) | async) }}-->
        <!--            </span>-->
        <!--            <div class="discount">{{ discount }}% {{ 'library.user-service-card.discount' | customLocale }}</div>-->
        <!--          </ng-template>-->
        <!--        </div>-->
        <div class="current-price">
          <span class="price">{{ getFormattedAmount() | async }}</span>
          <span class="period">{{ labelPeriod | customLocale }}</span>
        </div>
      </div>

      <div #injectedActions5Ref>
        <ng-container *ngTemplateOutlet="injectedServiceCardActions"></ng-container>
      </div>
      <ng-template [ngIf]="injectedActions5Ref?.childElementCount === 0">
        <ng-template [ngIf]="!canEdit">
          <ng-container *ngTemplateOutlet="signupActionRef"></ng-container>
        </ng-template>
      </ng-template>
    </div>
  </article>
</ng-template>

<ng-template #narrowMode>
  <article
    class="service-card narrow"
    [class.mobile]="deviceService.isMobile()"
    itemscope
    itemtype="https://schema.org/Article">
    <ng-container *ngTemplateOutlet="meta"></ng-container>

    <div *ngIf="isBrowser" class="card-cover" (click)="onOpenCardInModal()"></div>

    <div class="type" [ngClass]="eUserServiceType[type]">{{ typeLabel(type) | customLocale }}</div>

    <ng-container *ngTemplateOutlet="toolsPanel"></ng-container>

    <div class="content">
      <div class="cover-wrap">
        <on-ui-cover [cover]="cover"></on-ui-cover>
      </div>

      <div class="info-block">
        <a [routerLink]="userServiceRoute" [attr.title]="fullTitle" class="text-block">
          <div class="category" [class.empty]="!category">{{ category }}</div>
          <div class="subject-wrap">
            <span class="subject">{{ subjectTitle }}</span>
            <ng-template [ngIf]="subjectIsNative">
              <span class="native">{{ 'library.user-service-card.native' | customLocale }}</span>
            </ng-template>
          </div>
          <h3 class="title">{{ title | striptags }}</h3>
        </a>

        <ng-template [ngIf]="!deviceService.isMobile()">
          <ng-container *ngTemplateOutlet="secondInfo"></ng-container>
          <ng-container *ngTemplateOutlet="teacherBlock"></ng-container>
        </ng-template>
      </div>
    </div>

    <ng-template [ngIf]="deviceService.isMobile()">
      <ng-container *ngTemplateOutlet="secondInfo"></ng-container>
      <ng-container *ngTemplateOutlet="teacherBlock"></ng-container>
    </ng-template>

    <div class="bottom-block">
      <div class="price-block">
        <div class="current-price">
          <span class="price">{{ getFormattedAmount() | async }}</span>
          <span class="period">{{ labelPeriod | customLocale }}</span>
        </div>
        <!--        <div class="old-price">-->
        <!--          <ng-template [ngIf]="discount">-->
        <!--            <span class="price-without-discount">-->
        <!--              {{ formatPriceWithoutDiscount(getPriceTier(price_tier) | async) }}-->
        <!--            </span>-->
        <!--            <div class="discount">{{ discount }}% {{ 'library.user-service-card.discount' | customLocale }}</div>-->
        <!--          </ng-template>-->
        <!--        </div>-->
      </div>

      <div class="action-block" [class.with-unavailable-reason]="signUpStatus()?.label">
        <div class="action-item">
          <on-ui-button
            class="poutline"
            label="collections.actions.details"
            [iconPosition]="'after'"
            (onclick)="onOpenCardInModal()">
            <app-icon [width]="10" [height]="10" file="chevron" icon="down"></app-icon>
            <div class="camera-icon"></div>
          </on-ui-button>
        </div>
        <div class="additional-actions" #injectedActions1Ref>
          <ng-container *ngTemplateOutlet="injectedServiceCardActions"></ng-container>
        </div>
        <ng-template [ngIf]="injectedActions1Ref?.childElementCount === 0">
          <ng-template [ngIf]="!canEdit">
            <div class="action-item">
              <ng-container *ngTemplateOutlet="signupActionRef"></ng-container>
            </div>
          </ng-template>
        </ng-template>
      </div>
    </div>
  </article>
</ng-template>

<ng-template #signupActionRef>
  <ng-template [ngIf]="service?.can?.signup" [ngIfThen]="availableActionsRef" [ngIfElse]="notAvailableActionsRef">
  </ng-template>

  <ng-template #availableActionsRef>
    <on-ui-button
      class="secondary"
      [label]="isRegularClass() ? 'library.user-service-card.subscribe' : 'library.user-service-card.sign-up-for-a-lesson'"
      (click)="openCheckoutModal()">
    </on-ui-button>
  </ng-template>

  <ng-template #notAvailableActionsRef>
    <div>
      <on-ui-button class="status" label="teacher-card.actions.no-available-hours"> </on-ui-button>
      <div class="unavailable-reason" *ngIf="signUpStatus().label">
        <a [routerLink]="signUpStatus().link">{{ signUpStatus().label | customLocale }}</a>
      </div>
    </div>
  </ng-template>
</ng-template>

<ng-template #ratingWrap>
  <app-rating [stats]="service.school_id ? school : authorStats"></app-rating>
</ng-template>

<ng-template #teacherBlock>
  <div class="teacher-block">
    <ng-container *ngIf="service.school_id; else teacherInfo">
      <div class="avatar-wrap school-avatar-wrap">
        <on-ui-cover [cover]="userAvatar"></on-ui-cover>
      </div>
      <span class="teacher-name" itemprop="author">{{ userAvatar?.title }}</span>
      <ng-container *ngTemplateOutlet="ratingWrap"></ng-container>
    </ng-container>
    <ng-template #teacherInfo>
      <app-author-info [user]="service.author"></app-author-info>
    </ng-template>
  </div>
</ng-template>

<ng-template #secondInfo>
  <div class="second-info">
    <div class="row">
      <span class="text">
        {{ (isSingle ? 'library.user-service-card.one-on-one' : 'library.user-service-card.group') | customLocale }}
      </span>
      <div class="separator"></div>
      <ng-template [ngIf]="isRegularClass" [ngIfElse]="otherServices">
        <span class="text">
          {{ 'teacher-card.stats.classes' | customLocale }} {{ 'event-calendar.ongoing' | customLocale }}
        </span>
        <div class="separator"></div>
      </ng-template>
      <ng-template #otherServices>
        <ng-template [ngIf]="meetings_limit">
          <span class="text">{{ 'teacher-card.stats.classes' | customLocale }} {{ meetings_limit }}</span>
          <div class="separator"></div>
        </ng-template>
      </ng-template>
      <!--      <span class="text">{{ 'library.user-service-card.entry-level' | customLocale }}</span>-->
      <!--      <div class="separator"></div>-->
      <span class="text"
        >{{ 'user-service-form-3.fields.label9' | customLocale }} {{ age_from }}-{{ formatAge(age_to) }}</span
      >
    </div>
    <div class="row">
      <ng-template [ngIf]="weekdaysToString()">
        <span class="text">{{ weekdaysToString() }}</span>
        <div class="separator"></div>
      </ng-template>
      <span class="text">{{ duration }} {{ 'library.user-service-card.min' | customLocale }}</span>
      <div class="separator"></div>
      <span class="text">{{ 'constructor.form-language-label' | customLocale }}: {{ languageTitle }}</span>
    </div>
  </div>
</ng-template>

<ng-template #toolsPanel>
  <div class="tools-panel">
    <ng-template *ngIf="author?.id">
      <app-subscribe [user_id]="service.author_id" class="subscribe-block"></app-subscribe>
    </ng-template>
    <div class="tools-box">
      <app-bookmark [item]="service" [type]="'service'" (favoriteChanged)="onFavoriteChanged()"></app-bookmark>

      <div #injectedTools6Ref>
        <ng-container *ngTemplateOutlet="injectedServiceCardMenu"></ng-container>
      </div>
      <ng-template [ngIf]="injectedTools6Ref?.childElementCount === 0">
        <on-ui-card-menu>
          <a class="menu-item warn" *ngIf="service.purl" [href]="service.purl">[⚠️] Panel</a>
          <div class="menu-item" *ngIf="debug$ | async" (click)="printDebugInfo()">DEBUG</div>
          <div class="menu-item" (click)="onOpenCardInModal()">
            {{ 'user-service-form-3.actions.previews' | customLocale }}
          </div>
          <div class="menu-item" *ngIf="service.can.edit" (click)="onEdit()">
            {{ 'user-profile.service-card.edit' | customLocale }}
          </div>
        </on-ui-card-menu>
      </ng-template>
    </div>
  </div>
</ng-template>

<ng-template #meta>
  <meta itemprop="url" content="{{ userServiceRoute }}" />
  <meta itemprop="name" content="{{ fullTitle }}" />
  <meta itemprop="datePublished" content="{{ hlp_dateToISOString(contentDate) }}" />
  <meta itemprop="image" content="{{ metaImageUrl || coverImageUrl }}" />
  <meta *ngIf="description" itemprop="description" content="{{ description | striptags }}" />
  <meta itemprop="headline" content="" />
  <!-- <meta itemprop="publisher" content="htts://onclass.com"/> -->
  <!-- keywords -->
  <meta itemprop="inLanguage" content="{{ service.language?.code }}" />
  <!-- discussionUrl -->
  <!-- <meta *ngIf="service.stats?.comments_count" itemprop="commentCount" content="{{ service.stats?.comments_count }}"/>-->
</ng-template>

<ng-template [ngIf]="alertOpened">
  <app-alert type="error">
    <ng-container alert-title>{{ 'user-profile.service-card.alert.title' | customLocale }}</ng-container>
    <ng-container alert-body>{{ 'user-profile.service-card.alert.text' | customLocale }}</ng-container>
    <ng-container alert-buttons>
      <on-ui-button
        label="user-profile.service-card.alert.close"
        class="poutline"
        data-test="cancel"
        (onclick)="alertOpened = false">
      </on-ui-button>
      <on-ui-button
        label="user-profile.service-card.alert.remove"
        class="danger"
        data-test="remove"
        (onclick)="onRemove()">
      </on-ui-button>
    </ng-container>
  </app-alert>
</ng-template>
